export default "/_next/static/chunks/fonts/Syne Mono-540ddd587f992a3a4d37e8db0d66518e.otf";